// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3fqmk","approved":"Status_approved__1hMA0","rejected":"Status_rejected__1FOwW","expired":"Status_expired__3UzRv","label":"Status_label__2FK_N"};